// frontend/src/page/registrationSuccess.js
import React from 'react';
import RegSuccess from "../components/login-success/LoginSuccess";

const RegistrationSuccess = () => {
  return (
    <div>
      <RegSuccess/>
    </div>
  );
};

export default RegistrationSuccess;
